import React from 'react';
import './Project.css';

function Project() {
  const projects = [
    // Your Personal Portfolio
    {
      title: 'My Portfolio Website',
      description: 'This is my personal portfolio website showcasing my profile, skills, and projects.',
      technologies: 'ReactJs',
      imageUrl: 'mob.jpg',
      altText: 'Portfolio Website',
      type: 'website',
      url: 'https://shigportfolio.pages.dev/'
    },
    {
      title: 'Minazuki',
      description: 'A fast-loading, ad-free movie streaming website.',
      technologies: 'ReactJs',
      imageUrl: 'https://i.imgur.com/GloPtMv.png',
      altText: 'Minazuki',
      type: 'website',
      url: 'https://minazuk.space/'
    },
    // Websites Created for Others
    {
      title: 'Stats Technical Sportswear',
      description: 'An e-commerce website for a custom sportswear brand.',
      technologies: 'ReactJs',
      imageUrl: 'https://i.imgur.com/XG4Kbgm.png',
      altText: 'Stats Technical Sportswear',
      type: 'website',
      url: 'https://www.statstechnicalsportwear.com/'
    },
    {
      title: 'Tapis PH',
      description: 'A fashion-forward e-commerce site focused on local apparel and custom clothing.',
      technologies: 'ReactJs',
      imageUrl: 'https://i.imgur.com/LT9eO5J.png',
      altText: 'Tapis PH',
      type: 'website',
      url: 'https://www.tapisph444.com'
    },
    {
      title: 'Grow A Garden Calculator',
      description: 'An online tool to help players calculate the growth potential of their fruits in roblox',
      technologies: 'ReactJs',
      imageUrl: 'https://i.imgur.com/6gmtnnl.png',
      altText: 'Grow A Garden Calculator',
      type: 'website',
      url: 'https://growagardencalculator.fun/'
    },

    // Games
    {
      title: 'Shapeshooter',
      description: 'Arcade shooter where geometric shapes have health values. Precision and strategy required!',
      technologies: 'Unity',
      imageUrl: 'https://i.imgur.com/eYMgwDA.jpeg',
      altText: 'Shapeshooter',
      type: 'game',
      downloadLink: 'https://github.com/RitsuKamado/Apps/releases/download/v1.0/ShapeShooter6.apk'
    },
    {
      title: 'HeroesArc',
      description: 'Survival game with scavenging, defense, and supernatural abilities.',
      technologies: 'Unity',
      imageUrl: 'https://i.imgur.com/KixREWZ.jpeg',
      altText: 'HeroesArc',
      type: 'game',
      downloadLink: 'https://github.com/RitsuKamado/Apps/releases/download/v1.0/Heroes.Arc.easy.apk'
    },
    {
      title: 'Snake3d',
      description: 'A 3D twist on the classic snake game. Eat to grow, avoid walls!',
      technologies: 'Unity',
      imageUrl: "https://i.imgur.com/uCst0ut.jpeg",
      altText: 'Snake3d',
      type: 'game',
      downloadLink: 'https://github.com/RitsuKamado/Apps/releases/download/v1.0/Snake3d.updated.apk'
    },
    {
      title: 'SuperBrickBreaker',
      description: 'Brick-smashing arcade action with power-ups and challenging levels.',
      technologies: 'Unity',
      imageUrl: 'https://i.imgur.com/a2itIgm.jpeg',
      altText: 'SuperBrickBreaker',
      type: 'game',
      downloadLink: 'https://github.com/RitsuKamado/Apps/releases/download/v1.0/Superbrickbreaker.updated.apk'
    },
    {
      title: 'Limbo',
      description: 'A basic Casino game where you bet on a rising multiplier and try to cash out before it crashes.',
      technologies: 'Unity',
      imageUrl: 'Limbo.jpg',
      altText: 'Limbo',
      type: 'game',
      downloadLink: '/downloads/Limbo.apk'
    }
  ];

  const portfolio = projects.filter(p => p.type === 'portfolio');
  const websites = projects.filter(p => p.type === 'website');
  const games = projects.filter(p => p.type === 'game');

  return (
    <div className='projectContainer'>
      <div className='proTitle'>

        <h1>Past Project Experience</h1>
        <p className='proLook'>Take a look at the projects I've done in the past.</p>
      </div>


      {/* Website Section */}
      <h2 className='sectionTitle'>🌐 Websites Created</h2>
      <div className='proContainer'>
        {websites.map((project, index) => (
          <div key={index} className='projectCard' style={{ animationDelay: `${index * 0.15}s` }}>
            <img className='projectImg' src={project.imageUrl} alt={project.altText} />
            <div className='projectContent'>
              <h2>{project.title}</h2>
              <p>{project.description}</p>
              <p className='technologies'>{project.technologies}</p>
              <a className='visitSiteBtn' href={project.url} target='_blank' rel='noopener noreferrer'>
                Visit Website
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Game Section */}
      <h2 className='sectionTitle'>🎮 Games Created</h2>
      <div className='proContainer' >
        {games.map((project, index) => (
          <div key={index} className='projectCard' style={{ animationDelay: `${index * 0.15}s` }}>
            <img className='projectImg' src={project.imageUrl} alt={project.altText} />
            <div className='projectContent'>
              <h2>{project.title}</h2>
              <p>{project.description}</p>
              <p className='technologies'>{project.technologies}</p>
              <a className='downloadBtn' href={project.downloadLink} download>
                Download
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Project;
